import { mergeStyles, IPivotStyles, getTheme } from '@fluentui/react';

const headerShadow = 'rgba(0, 0, 0, 0.133) 0px 1.6px 3.6px 0px, rgba(0, 0, 0, 0.11) 0px 0.3px 0.9px 0px';
const palette = getTheme().palette;
export const pivotItemStyles: Partial<IPivotStyles> = {
  linkIsSelected: {
    padding: 0,
    marginRight: 0,
    height: '100%',
    color: palette.themePrimary,
    selectors: {
      ':hover': { color: palette.themePrimary }
    }
  },
  link: { padding: 0, marginRight: 0, height: '3.75rem' },
  root: { width: '5.25rem', height: '3.75rem', display: 'inline-block', verticalAlign: 'top' }
};
export const pivotContainerStyle = mergeStyles({
  display: 'inline-block'
});
export const headerContainer = mergeStyles({
  width: '100%',
  height: '3.875rem',
  padding: '0.0625rem 0',
  boxShadow: headerShadow,
  overflow: 'hidden',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginBottom: 2
});
export const headerCenteredContainer = mergeStyles(headerContainer, {
  justifyContent: 'center'
});

export const separatorContainerStyle = mergeStyles({
  display: 'inline-block',
  // padding: '0 1rem',
  height: '1.875rem'
});
export const pivotItemStyle = mergeStyles({
  padding: '0 0.8125rem'
});
export const pivotItemChatStyle = mergeStyles({
  padding: '0 0.8125rem',
  cursor: 'pointer',
  display: 'flex !important',
  height: '100%',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start',
  alignItems: 'center',
  selectors:{
    ':hover': {
      backgroundColor: 'rgb(243, 242, 241)'
    }
  }
});

export const pivotItemChatSelectedStyle = mergeStyles({
  padding: '0 0.8125rem',
  color: 'rgb(0, 120, 212)',
  cursor: 'pointer',
  display: 'flex !important',
  height: '100%',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start',
  alignItems: 'center',
  borderBottom: '2px solid',
  selectors:{
    ':hover': {
      backgroundColor: 'rgb(243, 242, 241)'
    }
  }
});

export const chatIconContainer = mergeStyles({
  display: 'flex',
  height: '100%'
});
export const countBadge = mergeStyles({
    position: 'absolute',
    width: '1rem',
    textAlign: 'center',
    marginTop: '0.9rem',
    marginLeft: '1.2rem',
    backgroundColor: 'rgb(215, 70, 84)',
    color: '#fff',
    borderRadius: '50%',
    fontSize: '10px'
});

export const separatorStyles = {
  root: {
    color: palette.neutralLight,
    width: '0.0625rem' // 1px
  }
};

export const showProfileDropdownStyle = mergeStyles({
  width: '8rem',
  maxWidth: '90%',
  padding: '20px 24px',
  cursor:'pointer'
});

export const editLabelStyle = mergeStyles({
  overflow: 'hidden'
});

export const profileModalStyles = mergeStyles({
  display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
    padding:'1rem 0'
});
export const personIconStyle = mergeStyles({
  cursor:'pointer'
});

export const modalHeaderStyle = mergeStyles({
  flex: '1 1 auto',
  display: 'flex',
  padding: '12px 12px 35px 0px',
});

export const iconButtonStyles = mergeStyles({
  position:'absolute',
  top:'10px',
  right:'15px',
  cursor:'pointer'
});

export const uploadButton = mergeStyles({
    marginTop:'1.2rem'
});

export const endcallbuttonStyle = mergeStyles({
  border:'0.125rem',
  textAlign:'left',
  cursor:'pointer',
  borderRadius:'2px',
  height:'1.1875rem',
  color:'#FFFFFF',
  backgroundColor:'rgb(215, 70, 84)',
  width:'8.5625rem',
  padding:'5px 0px 5px 10px'
});